import { styled } from "@mui/material/styles";

import Placeholder from "components/Placeholder";

export const Root = styled("div")({
  "& div p": {
    maxWidth: "none",
    marginBottom: "22px",
    textAlign: "left",
  },
});

export const StyledPlaceholder = styled(Placeholder)({
  height: "500px",
  margin: "30px auto",
});
